import { render, staticRenderFns } from "./FirmsPage.vue?vue&type=template&id=22028a65&scoped=true"
import script from "./FirmsPage.vue?vue&type=script&lang=ts"
export * from "./FirmsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22028a65",
  null
  
)

export default component.exports